import { render, staticRenderFns } from "./discountRecord.vue?vue&type=template&id=ca77fd62&scoped=true&"
import script from "./discountRecord.vue?vue&type=script&lang=js&"
export * from "./discountRecord.vue?vue&type=script&lang=js&"
import style0 from "./discountRecord.vue?vue&type=style&index=0&id=ca77fd62&scoped=true&lang=css&"
import style1 from "./discountRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca77fd62",
  null
  
)

export default component.exports